import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FieldLabel = ({ disabled, htmlFor, label, required }) => {
  if (!label) {
    return null;
  }

  return (
    <label
      className={classNames('gn-fieldLabel', { 'gn-fieldLabel--disabled': disabled })}
      htmlFor={htmlFor}
    >
      {label}{required && <span className="gn-fieldLabel__requiredMark">&nbsp;*</span>}
    </label>
  );
};

FieldLabel.propTypes = {
  disabled: PropTypes.bool,
  htmlFor: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
};

export default FieldLabel;
